// /confirm-email?c=<companyId>&t=<token>: where the "Confirm this address"
// button in the confirmation email lands. Public (no sign-in): whoever owns the
// inbox clicks it, and they may not have a console account at all.
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { confirmRecipient } from "../api";
import { BrandMark } from "../components/BrandMark";

type State = { kind: "working" } | { kind: "ok"; email: string } | { kind: "error"; message: string };

export function ConfirmEmailPage() {
  const [params] = useSearchParams();
  const [state, setState] = useState<State>({ kind: "working" });
  // StrictMode runs effects twice in dev; a link confirms only once
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const c = params.get("c") ?? "";
    const t = params.get("t") ?? "";
    confirmRecipient(c, t)
      .then((r) => setState({ kind: "ok", email: r.email }))
      .catch((e) => setState({ kind: "error", message: (e as Error).message }));
  }, [params]);

  return (
    <div className="confirm-page">
      <div className="confirm-card card">
        <BrandMark size={34} nameSize={24} />
        {state.kind === "working" && <p className="muted">Confirming your address…</p>}
        {state.kind === "ok" && (
          <>
            <CheckCircle2 size={36} className="confirm-page-ok" aria-hidden="true" />
            <h1>Address confirmed</h1>
            <p>
              <strong>{state.email}</strong> will now receive homeowner enquiries from xenquote. You can close this page.
            </p>
          </>
        )}
        {state.kind === "error" && (
          <>
            <XCircle size={36} className="confirm-page-bad" aria-hidden="true" />
            <h1>We couldn't confirm this address</h1>
            <p>{state.message}</p>
          </>
        )}
      </div>
    </div>
  );
}
